import React from 'react';
import T from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import cypressIds from 'Components/cypress_ids.json';
import texts from 'Components/texts.json';
import { applyCypressData } from 'Utilities/helpers';

import type { SimilarVehiclesEvents } from '../SimilarVehicles/SimilarVehicles';

import { useOnSeeAllVehiclesLinkClick } from './useOnSeeAllVehiclesLinkClick';

export interface SeeAllVehiclesLinkProps {
	normalisedMake?: string;
	normalisedModel?: string;
	onSeeAllVehiclesLinkClick?: SimilarVehiclesEvents['onViewAllVehiclesClick'];
	shouldUseMakeAndModelFilter?: boolean;
}

T.setTexts(texts);

export const SeeAllVehiclesLink: React.FC<SeeAllVehiclesLinkProps> = ({
	normalisedMake,
	normalisedModel,
	onSeeAllVehiclesLinkClick,
	shouldUseMakeAndModelFilter,
}) => {
	const onClick = useOnSeeAllVehiclesLinkClick({
		normalisedMake,
		normalisedModel,
		onSeeAllVehiclesLinkClick,
		shouldUseMakeAndModelFilter,
	});

	return (
		<Hyperlink
			{...applyCypressData(cypressIds.links.similarVehiclesSeeAllVehicles)}
			as="a"
			label={T.translate('vehicleDetails.similarVehicles.seeAllVehicles')}
			onClick={onClick}
		/>
	);
};
